export type ScheduleProfileRef = {
  id?: string;
  code?: string | null;
  name?: string | null;
};

export type FmbThaliListRecord = {
  id?: string;
  fmbId?: string;
  thaliNo?: string;
  deliveryAddress?: string | null;
  deliveryMohallah?: string | null;
  deliveryScheduleProfileId?: string | null;
  deliveryScheduleProfile?: ScheduleProfileRef | null;
  thaliTypeId?: string | null;
  tags?: string[];
  distributorId?: string | null;
  isActive?: boolean;
  fmb?: {
    itsNo?: string;
    name?: string;
    deliveryScheduleProfile?: ScheduleProfileRef | null;
  } | null;
};

export function formatThaliDeliveryAddress(record: FmbThaliListRecord | null | undefined): string {
  const parts = [record?.deliveryAddress, record?.deliveryMohallah]
    .map((x) => (typeof x === "string" ? x.trim() : ""))
    .filter(Boolean);
  return parts.length ? parts.join(" — ") : "—";
}

export function resolveThaliScheduleProfile(
  record: FmbThaliListRecord | null | undefined
): ScheduleProfileRef | null {
  return record?.deliveryScheduleProfile ?? record?.fmb?.deliveryScheduleProfile ?? null;
}

export function resolveThaliScheduleProfileId(
  record: FmbThaliListRecord | null | undefined
): string | null {
  const profile = resolveThaliScheduleProfile(record);
  const id = profile?.id ?? record?.deliveryScheduleProfileId;
  return id != null && String(id).trim() ? String(id) : null;
}

export function formatScheduleProfileLabel(profile: ScheduleProfileRef | null | undefined): string {
  if (!profile) {
    return "—";
  }
  const code = (profile.code ?? "").trim();
  const name = (profile.name ?? "").trim();
  if (code && name) {
    return `${code} — ${name}`;
  }
  return code || name || "—";
}

export function formatThaliHouseholdLabel(
  fmb: { itsNo?: string; name?: string } | null | undefined
): string {
  const its = (fmb?.itsNo ?? "").trim() || "—";
  const name = (fmb?.name ?? "").trim();
  return name ? `${its} · ${name}` : its;
}

export function formatThaliTagsList(tags: string[] | undefined): string {
  if (!tags?.length) {
    return "—";
  }
  const list = [...tags]
    .map((tag) => tag.trim())
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));
  return list.length ? list.join(", ") : "—";
}

export function fmbThaliListRowClickPath(record: FmbThaliListRecord | undefined): string | false {
  const fmbId = record?.fmbId;
  return fmbId ? `/fmbData/${fmbId}/show` : false;
}
